import { debounce } from 'lodash';
import '../helpers/closestPolyfill';


export function initializeAnchorLinks() {
    let containers = document.querySelectorAll('[data-anchor-links-container]');
    [].forEach.call(containers, (container) => {
        new AnchorLinks(container as HTMLElement);
    })
}

class AnchorLinks {
    [x: string]: any; // // hack for wierd typescript error: classList does not exist on type AnchorLinks
    container: HTMLElement;
    anchorLinksDiv: HTMLElement;
    triggers: HTMLButtonElement[] = [];
    contentTitles: HTMLElement[] = [];

    constructor(container: HTMLElement) {
        this.container = container;
        this.anchorLinksDiv = container.querySelector('[data-anchor-links]') as HTMLElement;

        let anchorItems = container.querySelectorAll('[data-anchor-link-title]');
        [].forEach.call(anchorItems, (item) => {
            this.contentTitles.push(item);
            this.setupAnchor(item);
        });

        window.addEventListener('scroll', debounce(() => {
            this.handleScrollOrResize();
        }, 50));
    }

    handleScrollOrResize = () => {
        
        let windowTop: number = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
            let containerBottomY = getElementY(this.container) + this.container.offsetHeight;

            if (windowTop < getElementY(this.contentTitles[0]) || windowTop > containerBottomY) {
                this.activateTrigger(-1);
                this.activateTitles(-1);
                this.anchorLinksDiv.classList.remove('sticky');
                this.triggers[0].classList.add('active');
                this.contentTitles[0].classList.add('active');
            }
            else {
                this.anchorLinksDiv.classList.add('sticky');
            }

            for (let i = 0; i < this.contentTitles.length; i++) {
                let titleY = getElementY(this.contentTitles[i]);

                let scrollOffset = window.innerHeight * .3 < 210 ? 210 : window.innerHeight * .3;

                let nextY = i == this.contentTitles.length - 1
                    ? containerBottomY
                    : getElementY(this.contentTitles[i + 1]);

                if (windowTop + 1 > titleY - scrollOffset && windowTop < nextY - scrollOffset) {
                    this.activateTrigger(i);
                    this.activateTitles(i);
                    
                }
            }
    }

    activateTrigger(index: number) {
        for (let i = 0; i < this.triggers.length; i++) {
            if (i === index) {
                this.triggers[i].classList.add('active');
            }
            else {
                this.triggers[i].classList.remove('active');
            }
        }
    }

    activateTitles(index: number) {
        for (let i = 0; i < this.contentTitles.length; i++) {
            if (i === index) {
                this.contentTitles[i].classList.add('active');
            }
            else {
                this.contentTitles[i].classList.remove('active');
            }
        }
    }

    setupAnchor = (item: HTMLElement) => {
        let title = item.getAttribute('data-anchor-link-title');

        let entry = document.createElement('button');
        entry.appendChild(document.createTextNode(title));
        entry.addEventListener('click', (e) => {
            this.scroll(item);
            let currentEntry = this; // hack for wierd typescript error: classList does not exist on type AnchorLinks
            currentEntry.classList.toggle('active');
        });
        this.anchorLinksDiv.appendChild(entry);

        this.triggers.push(entry);
    }

    scroll = (element: HTMLElement, duration: number = 1000) => {
        const scrollLinkOffset = 200;
        let startingY = window.pageYOffset;
        let elementY = getElementY(element);

        // If element is close to page's bottom then window will scroll only to some position above the element.
        var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
        var diff = targetY - startingY - scrollLinkOffset
        // Easing function: easeInOutCubic
        // From: https://gist.github.com/gre/1650294
        var easing = function (t) { return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1 }
        var start;

        if (!diff) return

        // Bootstrap our animation - it will get called right before next frame will be rendered.
        window.requestAnimationFrame(function step(timestamp) {
            if (!start) start = timestamp;
            // Elapsed miliseconds since start of scrolling.
            var time = timestamp - start;
            // Get percent of completion in range [0, 1].
            var percent = Math.min(time / duration, 1);
            // Apply the easing.
            percent = easing(percent);

            window.scrollTo(0, startingY + diff * percent);

            // Proceed with animation as long as we wanted it to.
            if (time < duration) {
                window.requestAnimationFrame(step);
            }
        })
    }
}

function getElementY(element: HTMLElement) {
    return window.pageYOffset + element.getBoundingClientRect().top;
}
//make the first nodes active on page load. Ideally this would be done in the backend on the node creation rather than in js.
window.addEventListener('load', () => {
    if (document.querySelector('[data-anchor-link-title]')) {
        document.querySelector('[data-anchor-link-title]').classList.add('active');
        document.querySelector('[data-anchor-links] button').classList.add('active');
    }
});